import c from "./c.png";
import css from "./css.png";
import html from "./html.jpg";
import java from "./java.png";
import javascript from "./javascript.png";
import python from "./python.webp";
import react from "./react.webp";
import sql from "./sql.png";
import tailwind from "./tailwind.jpeg";
import typescript from "./typescript.svg";

const skills = [
  { name: "Java", icon: java },
  { name: "C", icon: c },
  { name: "Python", icon: python },
  { name: "Javascript", icon: javascript },
  { name: "HTML", icon: html },
  { name: "CSS", icon: css },
  { name: "Typescript", icon: typescript },
  { name: "React", icon: react },
  { name: "Tailwind", icon: tailwind },
  { name: "SQL", icon: sql },
];

export { skills };
